import { getStyleDeclaration } from './get-style-declaration.js';
import { px2em } from '../../px2em/@impl/px2em.js';
import { widgetSelector } from './helpers';

export function scrollContainerWidget(widgetDescription) {
  return scrollContainerWidgetV1(widgetDescription);
}

function scrollContainerWidgetV1(widgetDescription) {
  const { placements, gap, vPadding, hPadding } = widgetDescription;

  const selector = widgetSelector(widgetDescription);

  const rules = [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
  ];

  rules.push([
    selector,
    [
      // ['padding', `${Math.max(vPadding, 8)}px ${px2em(hPadding)} ${Math.max(vPadding, 8)}px`],
      // ['padding', `calc(8px + ${px2em(vPadding)}) ${px2em(hPadding)}`],
      ['padding', `calc(8px + ${px2em(vPadding)}) 0`],
      // ['height', `calc(${placements[0].height} + ${Math.max(vPadding, 8)}px)`],
      ['height', placements[0].height],
    ],
  ]);

  // instead gap, due to flex gap still not have widely support
  rules.push([
    `${selector} > *:not(:last-child)`,
    [['margin-right', px2em(gap)]],
  ]);

  /*
   * define width for fake, empty block ::before and ::afet equal to hPadding,
   * due to margin collapsed and does not work
   * static property in scroll-container-module.css
   */
  rules.push([
    `${selector}::before, ${selector}::after`,
    [['width', px2em(hPadding)]],
  ]);

  return rules;
}

/**
 *
 * Just for experiment, try to manual construct container and wrapper.
 *
 * Assume: scroll wrapper expanded to all available place from top of screen
 * to bottom of container and make scroll, internally contain real items container.
 *
 */
// eslint-disable-next-line no-unused-vars
function scrollContainerWidgetV2(widgetDescription) {
  const {
    placements,
    gap,
    // vPadding,
    hPadding,
  } = widgetDescription;

  const selector = widgetSelector(widgetDescription);

  placements.forEach((variant) => {
    variant.width = 'auto';
  });

  const rules = [
    ...placements.map(getStyleDeclaration.positions(`${selector} > div`)),
    ...placements.map(getStyleDeclaration.size(`${selector} > div`)),
  ];
  const [placement] = placements;

  const wrapperProperties = [
    ['position', 'absolute'],
    ['overflow-x', 'auto'],
    ['overflow-y', 'hidden'],
    ['top', 0],
    ['height', `calc(100% - ${placement.bottom})`],
    ['left', '0'],
    ['width', '100%'],
  ];

  rules.push([selector, wrapperProperties]);
  const properties = [
    ['display', 'flex'],
    ['flex-direction', 'row'],
    ['justify-content', 'flex-start'],
    ['align-items', 'center'],
    ['flex-wrap', 'nowrap'],
    ['overflow', 'visible'],
    ['padding', `0 ${px2em(hPadding)}`],
    ['min-width', '100%'],

    /* some "magic"(?) to avoid unnecessary scroll bar
     when content's total width equal to full container width.
      It's something strange with it, disabling for a while.
      */
    // [ 'width', `calc(100% + ${px2em(padding)})` ]

    // ['gap', px2em(gap)], /* flex gap may cause problem, see below */
  ];

  rules.push([`${selector} > div`, properties]);

  // instead gap, due to flex gap still not have widely support
  rules.push([
    `${selector} > div > *:not(:last-child)`,
    [['margin-right', CSS.px(gap).toString()]],
  ]);

  // scroll bar styling
  const scrollbarColor = 'rgba(255, 255, 255, 0.2)';

  rules.push([
    `${selector}`,
    [
      ['scrollbar-width', 'thin'],
      ['scrollbar-color', scrollbarColor],
    ],
  ]);
  rules.push([
    `${selector}::-webkit-scrollbar`,
    [
      ['height', '0.5rem'],
      ['width', '0.5rem'],
      ['background-color', scrollbarColor],
    ],
  ]);
  rules.push([
    `${selector}::-webkit-scrollbar-thumb`,
    [['background-color', scrollbarColor]],
  ]);

  // reset child positioning
  const reset = [
    ['position', 'relative !important'],
    // [ 'width', 'auto !important' ],
    // [ 'height', '100% !important' ],
    ['left', 'initial !important'],
    ['bottom', 'initial !important'],
    ['top', 'initial !important'],
    ['min-width', 'initial !important'], // 🤯
    ['padding', '0'],
  ];

  rules.push([`${selector} > div > *`, reset]);
  return rules;
}
